import ActionsForm from '@/shared/mixins/actionsForm'
import AccrediteddateRepository from '@/shared/http/repositories/realestate/accrediteddate'
import { toast, loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'Tableaccredited',
  mixins: [ActionsForm],
  data () {
    return {
      head: ['IMOBILIARIA', 'N° EMPREENDIMENTOS', 'N° CORRETORES', 'N° ADMINISTRADOR', 'CIDADE', 'UF', 'STATUS', 'DT. DE CADASTRO', ''],
      status: '',
      dataInfo: [],
      res: [],
      filter: localStoreHelper.gestao.credenciada() || {},
      isFilter: localStoreHelper.gestao.credenciada() || false
    }
  },
  methods: {
    onLoad () {
      loading.push()
      if (this.isFilter) {
        AccrediteddateRepository.GetRequestsByFiltro(this.$refs.tableGrids.pagingLimit, this.$refs.tableGrids.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              loading.pop()
              let newRequestsArray = res.data.data
              let newResponse = res
              this.dataInfo = newRequestsArray
              this.$refs.tableGrids.LoadAllByData(newResponse)
            }
          })
          .catch((err) => {
            console.log(err)
            loading.close()
          })
        return
      }
      AccrediteddateRepository.GetAllPaging(this.$refs.tableGrids.pagingLimit, this.$refs.tableGrids.pagingIndex)
        .then(Response => {
          loading.pop()
          this.dataInfo = Response.data.data
          this.$refs.tableGrids.LoadAllByData(Response)
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },

    edit () {
      this.$emit('edit')
    },
    deleteAccredited () {
      this.$emit('deleteAccredited')
    },
    onChange (data) {
      loading.push()
      AccrediteddateRepository.PutInativeAccredited(data.id)
        .then(Response => {
          this.onLoad()
          toast.success(`Credenciada inativada com sucesso`)
          loading.pop()
        })
        .catch(Error => {
          toast.error(`Erro ao inativar a Credenciada`)
          loading.pop()
        })
    },
    searchWithFilter (filter, isFilter) {
      this.filter = filter
      this.isFilter = isFilter
      if (!this.isFilter) {
        this.$refs.tableGrids.pagingIndex = 1
        this.$refs.tableGrids.currentPage = 1
      }
      console.log(this.filter)
      AccrediteddateRepository.GetRequestsByFiltro(this.$refs.tableGrids.pagingLimit, this.$refs.tableGrids.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            let newRequestsArray = res.data.data
            let newResponse = res
            this.dataInfo = newRequestsArray
            this.$refs.tableGrids.LoadAllByData(newResponse)
          }
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/tableaccredited/tableaccredited.js